import Vue from 'vue'
import App from './App.vue'
import VueCompositionApi from '@vue/composition-api'
import router from './router'
import VueAnalytics from 'vue-analytics'

Vue.use(VueCompositionApi)
Vue.use(VueAnalytics, {
  id: 'UA-153883574-1',
  sendHitTask: process.env.NODE_ENV === 'production',
  router,
})
// Vue.use(VueCompositionApi)
Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
